<h2 class="fw-bold f-size-24 mb-5">ტრანზაქციების ისტორია</h2>

<div class="transaction">
  <div class="transaction__header transaction__grids">
    <p class="fw-medium">მომსახურება</p>
    <p class="fw-medium">ტრანზაქციების მიზანი</p>
    <p class="fw-medium">თანხა</p>
    <p class="fw-medium">სტატუსი</p>
    <p class="fw-medium">თარიღი</p>
  </div>

  <!-- this div is for loop -->
  <div
    *ngFor="let item of transactionsHistoryListing"
    class="transaction__body transaction__grids"
  >
    <div class="transaction__body__auction">
      <p class="fw-medium mb-2 d-md-none d-block">მომსახურება</p>
      <p *ngIf="item.auction_title">{{ item.auction_title }}</p>
    </div>
    <div class="transaction__body__transaction">
      <p class="fw-medium mb-2 d-md-none d-block">ტრანზაქციების მიზანი</p>
      <p>{{ item.transaction_title }}</p>
    </div>
    <div class="transaction__body__price">
      <p class="fw-medium mb-2 d-md-none d-block">თანხა</p>
      <p>{{ item.amount }} ლარი</p>
    </div>
    <div class="transaction__body__status">
      <p class="fw-medium mb-2 d-md-none d-block">სტატუსი</p>
      <p
        class="transaction__dot transaction__dot__paid"
        [ngClass]="{
          transaction__dot__red:
            item.transaction_type === 'warranty-for-auction'
        }"
      >
        {{ item.status_title }}
      </p>
    </div>
    <div class="transaction__body__date">
      <p class="fw-medium mb-2 d-md-none d-block">თარიღი</p>
      <p>{{ formatDate(item.created_at) }}</p>
    </div>
  </div>
</div>

<div
  *ngIf="totalItems > 15"
  class="listing__custom-pagination col-12 d-flex justify-content-center mb-3 mt-4"
>
  <span
    class="listing__custom-pagination__left-arrow mr-3 listing__custom-pagination__circle border rounded-circle d-flex justify-content-center align-items-center"
    (click)="decreaseCurrentPage()"
  >
    <img src="../../../../assets/images/right-arrow.svg" alt="arrow" />
  </span>
  <div *ngFor="let item of total">
    <div
      *ngIf="
        item === currentPage - 1 ||
        item === currentPage ||
        item === currentPage + 1
      "
      [ngClass]="{
        'listing__custom-pagination__active f-color-white': currentPage === item
      }"
      class="listing__custom-pagination__circle rounded-circle d-flex justify-content-center align-items-center f-color-dark mx-2"
      (click)="fPagination(item)"
    >
      <span>{{ item }}</span>
    </div>
  </div>
  <span
    class="ml-3 listing__custom-pagination__circle d-flex justify-content-center align-items-center border rounded-circle"
    (click)="increaseCurrentPage()"
  >
    <img src="../../../../assets/images/right-arrow.svg" alt="arrow" />
  </span>
</div>
